<div class="row row_flex mt-0">
  <div class="col-md-6">
    <!--<button
      mat-raised-button
      color="primary"
      class="save_secondary"
      cdkFocusInitial
    >
      <mat-icon>edit</mat-icon>Compose
    </button>-->
  </div>
  <div class="col-md-6">
    <span mat-dialog-close matSuffix class="float-right" (click)="closeMail()">
      <mat-icon>close</mat-icon>
    </span>
  </div>
</div>
<!--Search Bar-->
<div class="row row_flex" *ngIf="isMailConfigured && !isMailLoading">
  <div class="col-md-12 p-0">
    <div class="search_field">
      <mat-form-field
        class="example-full-width greenBorder MSB16"
        style="vertical-align: middle"
        floatLabel="never"
      >
        <input
          type="text"
          placeholder="Search"
          #search
          [formControl]="mailSearch"
          matInput
          (keyup)="applyFilter($event)"
        />
        <span matSuffix>
          <mat-icon class="align-bottom">search</mat-icon>
        </span>
      </mat-form-field>
    </div>
  </div>
</div>
<!--Paginator-->
<div class="row row_flex" [hidden]="!isMailConfigured || isMailLoading">
  <div class="col-md-12">
    <div class="card" style="border-radius: 10px">
      <mat-paginator
        [length]="totalMailCount"
        showFirstLastButtons
        class="MM14"
        [pageSize]="10"
        [pageIndex]="pageIndex"
        #paginator
        aria-label="Select page"
        (page)="mailPagination($event)"
      >
      </mat-paginator>
    </div>
  </div>
</div>
<!--Refresh button-->
<div class="row row_flex" *ngIf="isMailConfigured && !isMailLoading">
  <div class="col-md-6">
    <button mat-raised-button (click)="refresh()" class="save_primary">
      Refresh<mat-icon>refresh</mat-icon>
    </button>
  </div>
</div>
<!--Mail Cards-->
<mat-accordion class="row_flex" *ngIf="isMailConfigured && !isMailLoading">
  <mat-expansion-panel
    class="mat-elevation-z0 expansion_flex"
    [expanded]="true"
    hideToggle
  >
    <mat-expansion-panel-header class="header_flex">
      <div class="row">
        <div class="col-md-10">
          <span class="MM18 font-weight-bold">
            All Inbox <mat-icon>keyboard_arrow_down</mat-icon>
          </span>
        </div>
        <div class="col-md-2">
          <span class="MM18 font-weight-bold">{{ this.mailCount }}</span>
        </div>
      </div>
    </mat-expansion-panel-header>
    <div
      class="card mail_card"
      [ngClass]="{ active: mail.readFlag === 'false' }"
      *ngFor="let mail of mails"
      (click)="openMail(mail)"
    >
      <div class="row">
        <div class="col-md-8 mb-2" *ngIf="!allowActions">
          <span class="MM18 weight_600 title_preview">{{
            mail.from.split("<")[0]
          }}</span>
        </div>
        <div class="col-md-7 mb-2" *ngIf="allowActions">
          <span class="MM18 weight_600 title_preview">{{
            mail.from.split("<")[0]
          }}</span>
        </div>
        <div class="col-md-4 text-center" *ngIf="!allowActions">
          <span class="MM14">{{ mail.receivedTime | date: "HH:mm" }}</span>
        </div>
        <div class="col-md-3 text-center" *ngIf="allowActions">
          <span class="MM14">{{ mail.receivedTime | date: "HH:mm" }}</span>
        </div>
        <div class="col-md-2" *ngIf="allowActions">
          <mat-icon
            *ngIf="allowActions"
            #menuTrigger="matMenuTrigger"
            (click)="$event.stopPropagation()"
            [matMenuTriggerFor]="dropMenu"
            >more_vert</mat-icon
          >
          <mat-menu #dropMenu="matMenu"
            ><!--style="top: 0px; right: 0px"-->
            <button
              (click)="checkMode('attachMail', mail)"
              class="MM14 font-weight-bold"
              mat-menu-item
            >
              <mat-icon style="color: #42deb1"> mail_outline</mat-icon>
              Attach Email to claim
            </button>
            <button
              (click)="checkMode('attachDoc', mail)"
              class="MM14 font-weight-bold"
              mat-menu-item
            >
              <mat-icon style="color: #42deb1">description</mat-icon>
              Attach all Docs. to claim
            </button>
          </mat-menu>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 mb-2">
          <span class="MM16 subject_preview">{{ mail.subject }}</span>
        </div>
        <div class="col-md-12">
          <span class="MM14 mail_preview">{{ mail.conent }}</span>
        </div>
      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion>

<!--Mail Configuration title-->
<div class="row row_flex" *ngIf="!isMailConfigured && !isMailLoading">
  <div class="col-md-12">
    <span class="PDM24">Setting up your Mailbox!</span>
  </div>
  <div class="col-md-12">
    <span class="MM14" style="font-weight: 500"
      >To set up your Integrated Mail box, Please follow the following 2 step
      process</span
    >
  </div>
  <div class="col-md-12">
    <span class="MM12" style="font-weight: 500; color: #737373"
      >Time duration: 5 mins</span
    >
  </div>
</div>

<!--Mail Steps Card-->
<div
  class="card config_card row_flex"
  *ngIf="!isMailConfigured && !isMailLoading"
>
  <div class="row">
    <div class="col-md-12">
      <span class="MM14 font-500">Step 01: </span>
    </div>
    <div class="col-md-12">
      <span class="MM18 font-weight-bold"> Your Credentials </span>
    </div>
    <div class="col-md-12">
      <span class="MM14 font-500"
        >Please select any one of the options below to sign up for the
        integrated mail box</span
      >
    </div>
    <div class="col-md-12">
      <div class="divider"></div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="card type_card" (click)="selectConfigType('gmail')">
        <div class="row">
          <div class="col-md-10">
            <span
              class="MM18 font-weight-bold align-middle"
              style="color: #013cdb"
              >Sign Up using Gmail<img
                style="width: 1.375rem; height: 1rem"
                class="ml-3"
                src="../../../../assets/icons/Shared/gmail.png"
            /></span>
          </div>
          <div class="col-md-2">
            <mat-icon
              class="align-middle"
              style="color: #013cdb"
              *ngIf="mailConfigType !== 'gmail'"
            >
              arrow_forward
            </mat-icon>
            <mat-icon
              class="align-middle"
              style="color: #42deb1"
              *ngIf="mailConfigType === 'gmail'"
              >check_circle
            </mat-icon>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="card type_card" (click)="selectConfigType('outlook')">
        <div class="row">
          <div class="col-md-10">
            <span
              class="MM18 font-weight-bold align-middle"
              style="color: #013cdb"
              >Sign Up using Outlook<img
                style="width: 1.375rem; height: 1rem"
                class="ml-3"
                src="../../../../assets/icons/Shared/outlook.png"
            /></span>
          </div>
          <div class="col-md-2">
            <mat-icon
              class="align-middle"
              style="color: #013cdb"
              *ngIf="mailConfigType !== 'outlook'"
              >arrow_forward</mat-icon
            >
            <mat-icon
              class="align-middle"
              style="color: #42deb1"
              *ngIf="mailConfigType === 'outlook'"
              >check_circle
            </mat-icon>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="card type_card" (click)="selectConfigType('yahoo')">
        <div class="row">
          <div class="col-md-10">
            <span
              class="MM18 font-weight-bold align-middle"
              style="color: #013cdb"
              >Sign Up using Yahoo<img
                style="width: 1.375rem; height: 1rem"
                class="ml-3"
                src="../../../../assets/icons/Shared/yahoo.png"
            /></span>
          </div>
          <div class="col-md-2">
            <mat-icon
              class="align-middle"
              style="color: #013cdb"
              *ngIf="mailConfigType !== 'yahoo'"
              >arrow_forward</mat-icon
            >
            <mat-icon
              class="align-middle"
              style="color: #42deb1"
              *ngIf="mailConfigType === 'yahoo'"
              >check_circle
            </mat-icon>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="card type_card" (click)="selectConfigType('other')">
        <div class="row">
          <div class="col-md-10">
            <span
              class="MM18 font-weight-bold align-middle"
              style="color: #013cdb"
              >Use other Email to Register</span
            >
          </div>
          <div class="col-md-2">
            <mat-icon
              class="align-middle"
              style="color: #013cdb"
              *ngIf="mailConfigType !== 'other'"
              >arrow_forward</mat-icon
            >
            <mat-icon
              class="align-middle"
              style="color: #42deb1"
              *ngIf="mailConfigType === 'other'"
              >check_circle
            </mat-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Yahoo Steps Card-->
<div
  class="card config_card row_flex"
  *ngIf="!isMailConfigured && mailConfigType === 'yahoo'"
>
  <div class="row mb-3">
    <div class="col-md-12">
      <span class="MM14 font-500">Step 02: </span>
    </div>
    <div class="col-md-12">
      <span class="MM18 font-weight-bold"> Permission to turn on access </span>
    </div>
    <div class="col-md-12">
      <span class="MM14 font-500"
        >To help you get access to all your emails on TrueCover & link them with
        the claims direclty, please follow these steps:</span
      >
    </div>
    <div class="col-md-12">
      <div class="divider"></div>
    </div>
  </div>
  <!--Step 01-->
  <div class="row mb-3">
    <div class="col-md-2">
      <span class="MM12">01.</span>
    </div>
    <div class="col-md-10">
      <span class="MM12">
        Please click on this link:
        <a
          class="MM14 font-weight-bold"
          href="https://help.yahoo.com/kb/SLN15241.html#cont1"
          target="_blank"
          rel="noopener noreferrer"
          >Grant Permission</a
        >
        <mat-icon class="align-middle" style="color: #013cdb"
          >arrow_forward</mat-icon
        >
      </span>
    </div>
  </div>
  <!--Step 02-->
  <div class="row mb-3">
    <div class="col-md-2">
      <span class="MM12">02.</span>
    </div>
    <div class="col-md-10 mb-3">
      <span class="MM12">
        Enter <span class="font-weight-bold">“TrueCover”</span> into the App’s
        name & Click on Generate password.
      </span>
    </div>
    <div class="col-md-6">
      <img
        style="width: 6.125rem; height: 6.563rem; margin-left: 3.5rem"
        src="../../../../assets/icons/Shared/yahoo_step1.png"
      />
    </div>
    <div class="col-md-6">
      <img
        style="width: 6.125rem; height: 6.563rem"
        src="../../../../assets/icons/Shared/yahoo_step2.png"
      />
    </div>
  </div>
  <!--Step 03-->
  <div class="row mb-3">
    <div class="col-md-2">
      <span class="MM12">03.</span>
    </div>
    <div class="col-md-10 mb-3">
      <span class="MM12">
        Please click on <span class="font-weight-bold">“Copy”</span> to copy
        your new Password. Once Copied, click on the sign in button down below
      </span>
    </div>
    <div class="col-md-12">
      <img
        style="width: 6.125rem; height: 6.563rem; margin-left: 3.5rem"
        src="../../../../assets/icons/Shared/yahoo_step3.png"
      />
    </div>
  </div>

  <!--Btn-->
  <div class="row">
    <div class="col-md-12">
      <button
        mat-raised-button
        class="save_primary"
        (click)="mailConfiguration('yahoo')"
      >
        Sign in to your Mailbox<mat-icon class="align-middle"
          >arrow_forward</mat-icon
        >
      </button>
    </div>
  </div>
</div>

<!--Google Steps Card-->
<div
  class="card config_card row_flex"
  *ngIf="!isMailConfigured && mailConfigType === 'gmail'"
>
  <div class="row mb-3">
    <div class="col-md-12">
      <span class="MM14 font-500">Step 02: </span>
    </div>
    <div class="col-md-12">
      <span class="MM18 font-weight-bold"> Permission to turn on access </span>
    </div>
    <div class="col-md-12">
      <span class="MM14 font-500"
        >To help you get access to all your emails on TrueCover & link them with
        the claims direclty, please follow these steps:</span
      >
    </div>
    <div class="col-md-12">
      <div class="divider"></div>
    </div>
  </div>
  <!--Step 01-->
  <div class="row mb-3">
    <div class="col-md-2">
      <span class="MM12">01.</span>
    </div>
    <div class="col-md-10">
      <span class="MM12">
        Please click on this link:
        <a
          class="MM14 font-weight-bold"
          href="https://myaccount.google.com/security?gar=1"
          target="_blank"
          rel="noopener noreferrer"
          >Grant Permission</a
        >
        <mat-icon class="align-middle" style="color: #013cdb"
          >arrow_forward</mat-icon
        >
      </span>
    </div>
  </div>
  <!--Step 02-->
  <div class="row mb-3">
    <div class="col-md-2">
      <span class="MM12">02.</span>
    </div>
    <div class="col-md-10 mb-3">
      <span class="MM12">
        Scroll down to <span class="font-weight-bold">switch on</span> access
        permission toggle on in the tab<span class="font-weight-bold"
          >“Less secure app access”</span
        >
      </span>
    </div>
    <div class="col-md-12">
      <img
        style="width: 17.5rem; height: 5.875rem; margin-left: 3.5rem"
        src="../../../../assets/icons/Shared/gmail_step1.png"
      />
    </div>
  </div>
  <!--Step 03-->
  <div class="row mb-3">
    <div class="col-md-2">
      <span class="MM12">03.</span>
    </div>
    <div class="col-md-10 mb-3">
      <span class="MM12">
        Provide access by <span class="font-weight-bold">Turning on </span>the
        toggle
      </span>
    </div>
    <div class="col-md-12">
      <img
        style="width: 9.688rem; height: 5.188rem; margin-left: 3.5rem"
        src="../../../../assets/icons/Shared/gmail_step2.png"
      />
    </div>
  </div>

  <!--Btn-->
  <div class="row">
    <div class="col-md-12">
      <button
        mat-raised-button
        class="save_primary"
        (click)="mailConfiguration('gmail')"
      >
        Sign in to your Mailbox<mat-icon
          class="align-middle"
          style="color: #013cdb"
          >arrow_forward</mat-icon
        >
      </button>
    </div>
  </div>
</div>

<!--Loader Implementation-->
<div class="row row_flex" style="margin-top: 50%;" *ngIf="isMailLoading">
  <div class="col-md-4"></div>
  <div class="col-md-4">
    <mat-spinner class="ml-3" style="color: #013cdb;" [diameter]="60" [strokeWidth]="5">
    </mat-spinner>
  </div>
  <div class="col-md-4"></div>
  <div class="col-md-12 text-center" style="margin-top: 2rem;">
    <span class="MM18 font-weight-bold">Fetching Mails</span>
  </div>
  <div class="col-md-12 text-center">
    <span class="MM14 font-weight-bold">
      This may take a minute or two if mail is configured recently.
    </span>
  </div>
</div>
